import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import HallOfWood from './components/HallOfWood';

function App() {
  return (
    <Router>
      <div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hall-of-wood" element={<HallOfWood />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
